import * as React from "react";

function SvgExport(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        d="M4.802 4.079c.274 0 .497.224.497.5 0 .277-.223.5-.497.5h-.27a1.949 1.949 0 00-1.913 1.956v6.008c0 1.08.868 1.955 1.939 1.955h7.278c1.07 0 1.938-.875 1.938-1.955V7.035c0-1.08-.868-1.955-1.938-1.955h-.271a.498.498 0 01-.497-.5c0-.277.222-.501.497-.501h.27a2.912 2.912 0 012.095.854c.557.555.87 1.312.87 2.102v6.008a2.97 2.97 0 01-.88 2.112 2.916 2.916 0 01-2.11.844H4.53C2.912 16 1.6 14.676 1.6 13.043V7.035c0-1.633 1.312-2.956 2.931-2.956zM8.183 0c.343 0 .67.146.9.4l.04.061 1.515 2.51a.509.509 0 01-.165.667.492.492 0 01-.682-.167L8.679 1.65v8.39c0 .276-.222.5-.496.5s-.496-.224-.496-.5V1.65L6.556 3.471a.488.488 0 01-.662.167.51.51 0 01-.166-.687L7.283.4c.231-.255.558-.401.9-.401z"
        fill="#22CDDB"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgExport;
